export default __webpack_public_path__ + "static/media/logo.4d53816f.png";